export default "https://ims.cellgalleryonline.com/api/v1/";
// export default "http://localhost:8080/api/v1/";